import { api } from "./useApi";
import { ValorVariacao } from "../types/Produto";

export const variacaoValoresApi = () => ({
  getValores: async (id_tipo?: number): Promise<ValorVariacao[]> => {
    let response = await api.post("variacao/valores", id_tipo ? { id_tipo } : {});
    return response.data;
  },
  // Upsert por (id_empresa, id_tipo, valor). Mandar cor_hex e imagem vazios limpa o swatch.
  // A imagem vai como base64 e sobe pro S3 no backend, igual pasta/salvar.
  salvarValor: async (dados: {
    id_tipo: number;
    valor: string;
    cor_hex?: string;
    imagem?: string;
  }): Promise<ValorVariacao> => {
    let response = await api.post("variacao/valores_acao/salvar", {
      cor_hex: "",
      imagem: "",
      ...dados,
    });
    return response.data;
  },
});